import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AppBar,
  Box,
  createTheme,
  IconButton,
  Stack,
  ThemeProvider,
  Toolbar,
  Typography,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { MAIN_ROUTE, SIGN_IN_ROUTE } from '../../constant/routes';
import {
  getDefaultAlertProps,
  getRootLevel,
  getViewType,
} from '../../utils/utils';
import { IAlertProps } from '../../interface/IAlertProps';
import { MyAlert } from '../UI/MyAlert';
import { FULLNAME_NAME, MOBILE_VIEW } from '../../constant/constants';

export const MainNavigationBar = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const root = getRootLevel();
  const darkTheme = createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#009688',
      },
    },
  });

  const logout = async () => {
    navigate(SIGN_IN_ROUTE);
  };

  const handleLogout = async () => {
    await logout();
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <MyAlert
        message={alertProps.message}
        severity={alertProps.severity}
        onClose={() => setAlertProps({ ...alertProps, message: '' })}
      />
      <ThemeProvider theme={darkTheme}>
        <AppBar position="static">
          <Toolbar>
            <Stack direction="row" width="100%" justifyContent="space-between">
              <Stack direction="row" alignItems="center" spacing={2}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={2}
                    onClick={() => navigate(MAIN_ROUTE)}
                  >
                    <Stack direction="row" alignItems="center" spacing={0}>
                      <Typography
                        style={{
                          fontFamily: 'sans-serif',
                          fontStyle: 'revert',
                          fontWeight: 750,
                          fontSize: '28px',
                          color: '#FFFFFF',
                        }}
                        component="text"
                      >
                        ISOft
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
              <Stack direction="row" alignItems="center" spacing={4}>
                {getViewType() !== MOBILE_VIEW && (
                  <Typography
                    style={{
                      fontFamily: 'sans-serif',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      fontSize: '16px',
                      color: '#FFFFFF',
                    }}
                    component="text"
                  >
                    {`${localStorage.getItem(FULLNAME_NAME)}`}
                  </Typography>
                )}
                <IconButton
                  size="large"
                  title="Выход"
                  edge="start"
                  color="inherit"
                  onClick={handleLogout}
                  aria-label="menu"
                >
                  <LogoutIcon />
                </IconButton>
              </Stack>
            </Stack>
          </Toolbar>
        </AppBar>
      </ThemeProvider>
    </Box>
  );
};
